import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {
  ICreateCustomerDissatisfactionReason,
  IUpdateCustomerDissatisfactionReason,
} from "../../models/customer-satisfaction/request";
import {
  ICustomerDissatisfactionReason,
  ICustomerSatisfactionAudit,
} from "../../models/customer-satisfaction/response";
import {
  ICustomerDissatisfactionReasonQuery,
  ICustomerSatisfactionAuditQuery,
} from "../../models/customer-satisfaction/query";

class CustomerDissatisfactionReasonService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAll = (
    query: ICustomerDissatisfactionReasonQuery,
    params?: RequestParams,
  ) =>
    this.http.request<IBaseListingResponse<ICustomerDissatisfactionReason>>({
      path: "/customer-dissatisfaction-reasons",
      method: "GET",
      query,
      ...params,
    });

  create = (
    data: ICreateCustomerDissatisfactionReason,
    params?: RequestParams,
  ) =>
    this.http.request<ICustomerDissatisfactionReason>({
      path: "/customer-dissatisfaction-reasons",
      method: "POST",
      body: data,
      ...params,
    });

  update = (
    id: number,
    data: IUpdateCustomerDissatisfactionReason,
    params?: RequestParams,
  ) =>
    this.http.request<ICustomerDissatisfactionReason>({
      path: `/customer-dissatisfaction-reasons/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  delete = (id: number, params?: RequestParams) =>
    this.http.request<ICustomerDissatisfactionReason>({
      path: `/customer-dissatisfaction-reasons/${id}`,
      method: "DELETE",
      ...params,
    });

  getAudits = (
    id: number,
    query: ICustomerSatisfactionAuditQuery,
    params?: RequestParams,
  ) =>
    this.http.request<IBaseListingResponse<ICustomerSatisfactionAudit>>({
      path: `/customer-dissatisfaction-reasons/${id}/audits`,
      method: "GET",
      query,
      ...params,
    });
}

export default CustomerDissatisfactionReasonService;
